module.exports = __webpack_public_path__ + "static/media/feature_vindbeggeveje.aab62740.jpg";